
import AudioSquare from "../../../assets/outline/AudioSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AudioSquareIcon({ className, dataTestid = "AudioSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <AudioSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
